import React, { useCallback, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { updateParams } from '@/redux/app/actions/navigation';
import { togglePauseInbox, toggleInboxCompactMode } from '@/redux/app/actions/settings';
import { accountHidePauseButtonSelector, inboxCompactModeSelector, inboxIsPausedSelector } from '@/redux/app/selectors/settings';

import { UserInfoContext } from '../user/user-info';

export interface InboxControlsProps {
  handleRefresh: () => void;
  handleToggleFilters: () => void;
  handleToggleFiltersOff: () => void;
  hasActiveFilters: boolean;
}

export const InboxControls = ({
  handleRefresh, handleToggleFilters, handleToggleFiltersOff, hasActiveFilters,
}: InboxControlsProps) => {
  const { userId } = useContext(UserInfoContext);
  const isPaused = useSelector(inboxIsPausedSelector);
  const hidePauseButton = useSelector(accountHidePauseButtonSelector);
  const compactMode = useSelector(inboxCompactModeSelector);

  const dispatch = useDispatch();
  const handleClickPause = useCallback(() => {
    dispatch(togglePauseInbox(userId));
  }, [userId, dispatch]);
  const handleClickClear = useCallback(() => {
    dispatch(updateParams(null));
    handleToggleFiltersOff();
  }, [dispatch]);
  const handleClickCompact = useCallback(() => {
    dispatch(toggleInboxCompactMode(userId));
  }, [userId, dispatch]);

  return (
    <div id="controls-wrapper">
      {!hidePauseButton && (
        <div id="pause-inbox-toggler">
          <button type="button" className={`btn btn-outline ui-link ${isPaused ? 'off' : 'on'}`} onClick={handleClickPause}> </button>
        </div>
      )}
      <div id="refresh-inbox-toggler" data-turbolinks="false">
        <button type="button" className="btn btn-outline ui-link" onClick={handleRefresh}> </button>
      </div>
      <div id="clear-inbox-toggler" data-turbolinks="false">
        <button type="button" className="btn btn-outline ui-link" onClick={handleClickClear}> </button>
      </div>
      <div id="filter-toggler">
        <button type="button" className={`btn btn-outline ${hasActiveFilters ? 'on' : 'off'} ui-link`} onClick={handleToggleFilters}> </button>
      </div>
      <div id="compact-inbox-toggler">
        <button type="button" className={`btn btn-outline ui-link ${compactMode ? 'on' : 'off'}`} onClick={handleClickCompact}> </button>
      </div>
    </div>
  );
};
